Submit

<template>
  <form-wizard class="full-width"
               color="rgba(var(--vs-primary), 1)"
               :title="null"
               :subtitle="null"
               finishButtonText="Submit"
               @on-complete="formSubmitted"
               @on-validate="handleValidation"
               @on-error="handleErrorMessage"
               :nextButton="null"
  >
    <template slot="footer" slot-scope="props">
      <div class="d-flex justify-content-between">
        <div class="wizard-footer-left">
          <vs-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()"
                     :style="props.fillButtonStyle">Wróć
          </vs-button>
        </div>
        <transition name="slide">

          <div class="wizard-footer-right" v-show="files.length && termsAccepted">
            <vs-button v-if="!props.isLastStep"
                       @click.native="props.nextTab()"
                       :style="props.fillButtonStyle"
                       color="success"
                       type="filled">
              Przejdź dalej
            </vs-button>


          </div>
        </transition>
      </div>

      <div v-if="props.isLastStep" class="d-flex justify-content-center full-width">
        <vs-button @click.native="confirm" class="finish-button"
                   :style="props.fillButtonStyle">Zatwierdź
        </vs-button>
      </div>
    </template>

    <tab-content title="Dodawanie Plików" class="mb-5" :before-change="validateFiles">

      <div class="vx-row justify-center">
        <div class="vx-col mt-6">
          <UploadFiles @change="updateFilesList"/>
        </div>
      </div>

      <div class="vx-row justify-center">
        <div class="vx-col">
          <VerificationTable :files="realFiles"/>
        </div>
      </div>

      <div class="vx-row justify-center">

        <div class="vx-col md:mt-2">
          <div class="demo-alignment">
            <div class="flex">
              <vs-checkbox v-model="termsAccepted">Akceptuję warunki korzystania z serwisu</vs-checkbox>
            </div>
          </div>
        </div>
      </div>

    </tab-content>

    <!-- tab 2 content -->
    <tab-content title="Wybór Banku" class="mb-5" :before-change="validateBank">
      <div class="vx-row justify-center">
        <div class="vx-col  w-full mt-8 mb-5">
          <h4 class="text-center ">Wybierz bank z którego pochodzi umowa</h4>
        </div>
        <div class="vx-col w-full lg:w-1/2 mt-5 mb-8">
          <multiselect v-model="bank" :options="$store.state.banks.filter(({archived}) => !archived).map(({name}) => name)"
                       placeholder="Wybierz bank" selectLabel="Wciśnij enter aby zaznaczyć"
                       deselectLabel="Wciśnij enter aby odznaczyć"></multiselect>
        </div>
      </div>
    </tab-content>

    <!-- tab 3 content -->
    <tab-content title="Odbiór wyników" class="mb-5">
      <ClientInfo v-model="client"/>
    </tab-content>

<!--    <pre>{{client}}</pre>-->

    <div v-if="errorMsg">
      <p class="error">{{errorMsg}}</p>
    </div>
  </form-wizard>
</template>

<script>
  import { FormWizard, TabContent } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import UploadFiles from './UploadFiles'
  import VerificationTable from './VerificationTable';
  import { validateEmail, validatePhone } from '../../utils/validators';
  import { EVENT_CLEAR_FILES, EventBus } from '../../utils/EventBus';
  import { analytics, events } from '../../utils/analitics';
  import ClientInfo from './ClientInfo';

  export default {
    name: 'UserUploadFlow',
    data() {
      return {
        errorMsg: null,
        confirmLoading: false,

        files: [],
        termsAccepted: false,
        bank: null,

        client: {
          name: '',
          surname: '',
          email: '',
          phone: '',
          info: { }
        },
      }
    },
    created() {
      this.files = [];
      EventBus.$once(EVENT_CLEAR_FILES, () => {
        this.files = [];
      })
    },
    computed: {
      realFiles() {
        return this.files.filter(f => f.id)
      }
    },
    methods: {
      fixFiles() {
        this.files = [...this.realFiles];
      },
      formSubmitted() {
        console.log('Form submitted!')
      },
      async confirm() {
        try {
          this.confirmLoading = true;
          const res = await this.validateConfirm();
          this.errorMsg = '';
          await this.$store.dispatch('confirm_agreement', {
            email: this.client.email,
            name: this.client.name,
            surname: this.client.surname,
            phone: this.client.phone,
            info: JSON.stringify(this.client.info),
            bank: this.bank,
            premiumSupport: this.client.premiumSupport,
            pages: this.realFiles
          });

          const id = this.$store.state.id;
          this.confirmLoading = false;
          return this.$router.push({ name: 'page-agreement-status', params: { id: id } });
        } catch (e) {
          console.log("E", e);
          this.errorMsg = e
        }
        this.confirmLoading = false;
      },
      handleValidation(isValid, tabIndex) {
        console.log(`Tab: ${tabIndex} valid: ${isValid}`)
      },
      handleErrorMessage(errorMsg) {
        this.errorMsg = errorMsg
      },
      updateFilesList(files) {
        console.log("UPDATE", files)
        this.files = files.filter(f => f.id)
      },
      async validateFiles() {
        return new Promise((resolve, reject) => {
          if (this.realFiles.length === 0) {
            reject('Nie możesz przejść dalej zanim nie dodasz dokumentów.')
          } else if (!this.realFiles.every(f => f.state === 'queued')) {
            reject('Nie możesz przejść dalej jeśli nie wszystkie dokumenty są poprawne.')
          } else {
            analytics.logEvent(events.files_validated, { files: this.realFiles });
            resolve(true)
          }
        })
      },
      async validateBank() {
        return new Promise((resolve, reject) => {
          if (this.$store.state.banks.map(({name}) => name).includes(this.bank)) {
            analytics.logEvent(events.bank_validated, { files: this.bank })
            resolve(true);
          } else {
            reject('Musisz wybrać bank z którym podpisano umowę zanim przejdziesz dalej.')
          }
        });
      },
      async validateConfirm() {
        console.log("validate.confirm");
        return new Promise((resolve, reject) => {
          if (!this.client.email) reject('Jeśli nie podasz adresu e-mail nie będziemy mogli wysłać Ci wyników analizy.');
          if (!validateEmail(this.client.email)) reject('Ten email wydaje się nie być poprawny, sprawdź czy wpisałeś dobry adres.')
          if (this.client.premiumSupport === false) {
            resolve(true)
          } else {
            if (!this.client.name) reject('Podaj swoje imię.')
            if (!this.client.surname) reject('Podaj swoje nazwisko.')
            if (!this.client.phone) reject('Podaj swój telefon.')
            if (!validatePhone(this.client.phone)) reject('Ten telefon wydaje się być nie poprawny. Sprawdź czy dobrze go wpisałeś.')
            resolve(true);
          }

        })
      }
    },
    components: {
      ClientInfo,
      VerificationTable,
      UploadFiles,
      FormWizard,
      TabContent
    }
  }
</script>

<style>
  .d-none {
    display: none;
  }

  .d-flex {
    display: flex;
  }

  .justify-content-between {
    justify-content: space-between;
  }


  .justify-content-center {
    justify-content: center;
  }

  .slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    /*-moz-transition-timing-function: ease-in;*/
    /*-webkit-transition-timing-function: ease-in;*/
    /*-o-transition-timing-function: ease-in;*/
    /*transition-timing-function: ease-in;*/
    transition-timing-function: linear;
  }

  .slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    /*-moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);*/
    /*-webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);*/
    /*-o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);*/
    /*transition-timing-function: cubic-bezier(0, 1, 0.5, 1);*/
    transition-timing-function: linear;
  }

  .slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }

  .error {
    text-align: center;
    color: crimson;
    margin: 1.5em;
  }
</style>
